var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"toggle",class:_vm.classNames},[_c('span',{staticClass:"toggle__btn"},[_c('input',{staticClass:"toggle__input",attrs:{"disabled":_vm.disabled,"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":_vm.onChange}}),_c('span',{staticClass:"toggle__check-mark"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }